import { Award, Smile, Star } from "lucide-react";

const GoogleG = ({ className = "h-5 w-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.9 29.3 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 6.1 29.4 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.2-.1-2.3-.4-3.5z"/>
    <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c3.1 0 5.9 1.2 8 3.1l5.7-5.7C34.3 7.1 29.4 5 24 5 16.3 5 9.6 9.3 6.3 14.7z"/>
    <path fill="#4CAF50" d="M24 44c5.3 0 10.1-2 13.7-5.3l-6.3-5.2C29.3 35.1 26.8 36 24 36c-5.3 0-9.7-3.1-11.3-7.5l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
    <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.1-4 5.5l6.3 5.2C41.4 35.6 44 30.2 44 24c0-1.2-.1-2.3-.4-3.5z"/>
  </svg>
);

const OshaBadge = ({ className = "h-5 w-5" }: { className?: string }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M12 2L4 5v6c0 5 3.4 9.6 8 11 4.6-1.4 8-6 8-11V5l-8-3z" fill="hsl(var(--primary))"/>
    <text x="12" y="14" textAnchor="middle" fontSize="6" fontWeight="700" fill="white" fontFamily="Arial, sans-serif">OSHA</text>
  </svg>
);

const items = [
  { icon: Award, label: "15+ Years Experience", brand: false },
  { icon: Smile, label: "10,000+ Happy Patients", brand: false },
  { icon: GoogleG, label: "4.9★ Google Rating", brand: true },
  { icon: OshaBadge, label: "OSHA Sterilization", brand: true },
];

const TrustBar = () => (
  <section className="bg-card border-y border-border">
    <div className="container py-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
        {items.map((it) => {
          const Icon = it.icon;
          return (
            <div key={it.label} className="flex items-center gap-3">
              <div className={`h-10 w-10 rounded-full flex items-center justify-center shrink-0 ${it.brand ? "bg-white border border-border" : "bg-primary/10"}`}>
                <Icon className={`h-5 w-5 ${it.brand ? "" : "text-primary"}`} />
              </div>
              <span className="text-sm font-heading text-foreground">{it.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  </section>
);

export default TrustBar;